module.exports = __webpack_public_path__ + "img/4.635684f2.png";